export default {
  modalTitle: {
    id: 'buyback_refurbisher_on_hold_modal_head_title',
    defaultMessage: 'Order {orderId}',
  },
  nextButton: {
    id: 'buyback_refurbisher_on_hold_modal_next_button',
    defaultMessage: 'Next',
  },
  submitButton: {
    id: 'buyback_refurbisher_on_hold_modal_submit_button',
    defaultMessage: 'Send',
  },
  sendCounterOfferButton: {
    id: 'buyback_refurbisher_on_hold_modal_send_counter_offer_button',
    defaultMessage: 'Send Counteroffer',
  },
  counterOfferSuccessToastTitle: {
    id: 'buyback_refurbisher_on_hold_modal_send_counter_offer_success_toast_title',
    defaultMessage: 'Counteroffer sent',
  },
  counterOfferSuccessToastMessage: {
    id: 'buyback_refurbisher_on_hold_modal_send_counter_offer_success_toast_message',
    defaultMessage:
      'Your order is on hold until the customer accepts or rejects the counteroffer.',
  },
  suspendSuccessToastTitle: {
    id: 'buyback_refurbisher_on_hold_modal_suspend_success_toast_title',
    defaultMessage: 'Message sent',
  },
  suspendSuccessToastMessage: {
    id: 'buyback_refurbisher_on_hold_modal_suspend_success_toast_message',
    defaultMessage:
      'A message have been sent to the customer and to the agent.',
  },
}
